module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073e0_banner_800x600.610f949f.png";